export enum EnclosureModel {
  Es12 = 'ES12',

  Es24F = 'ES24F',
  Es24 = 'ES24',
  Es24N = 'ES24N',

  Es60 = 'ES60',
  Es60G2 = 'ES60G2',
  Es60G3 = 'ES60G3',

  Es102 = 'ES102',
  Es102G2 = 'ES102G2',

  F60 = 'F60',
  F100 = 'F100',
  F130 = 'F130',

  H10 = 'H10',
  H20 = 'H20',
  H30 = 'H30',

  M30 = 'M30',
  M40 = 'M40',
  M50 = 'M50',
  M60 = 'M60',

  Mini3E = 'MINI-3.0-E',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Mini3EPlus = 'MINI-3.0-E+',
  Mini3X = 'MINI-3.0-X',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Mini3XPlus = 'MINI-3.0-X+',
  Mini3XlPlus = 'MINI-3.0-XL+',
  MiniR = 'MINI-R',

  R10 = 'R10',
  R20 = 'R20',
  R20A = 'R20A',
  R20B = 'R20B',
  R30 = 'R30',
  R40 = 'R40',
  R50 = 'R50',
  R50B = 'R50B',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  R50BM = 'R50BM',
  R60 = 'R60',

  V140 = 'V140',
  V160 = 'V160',
  V260 = 'V260',
  V280 = 'V280',

  X10 = 'X10',
  X20 = 'X20',
}
